/**
 * Defers slideshow video network load until the slide is active.
 * Pauses inactive slide videos; only hydrates sources for the current viewport.
 */
(function () {
  const MOBILE_MQ = '(max-width: 768px)';

  function isMobileViewport() {
    return window.matchMedia(MOBILE_MQ).matches;
  }

  function videosForViewport(slide) {
    return Array.from(slide.querySelectorAll('video[data-slideshow-deferred-video]')).filter((video) => {
      if (video.classList.contains('slideshow__video--desktop')) return !isMobileViewport();
      if (video.classList.contains('slideshow__video--mobile')) return isMobileViewport();
      return true;
    });
  }

  function hydrateSources(video) {
    let changed = false;
    video.querySelectorAll('source[data-src]').forEach((source) => {
      if (!source.getAttribute('src')) {
        source.setAttribute('src', source.getAttribute('data-src'));
        changed = true;
      }
    });
    if (changed || !video.dataset.hydrated) {
      video.dataset.hydrated = 'true';
      video.load();
    }
  }

  function playVideos(slide) {
    if (!slide) return;
    videosForViewport(slide).forEach((video) => {
      hydrateSources(video);
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    });
  }

  function pauseVideos(slide) {
    if (!slide) return;
    slide.querySelectorAll('video[data-slideshow-deferred-video]').forEach((video) => {
      video.pause();
    });
  }

  function syncSlideVideos(component, activeSlide) {
    component.querySelectorAll('.slideshow__slide').forEach((slide) => {
      if (slide === activeSlide) {
        playVideos(slide);
      } else {
        pauseVideos(slide);
      }
    });
  }

  function onSlideChanged(event) {
    syncSlideVideos(event.currentTarget, event.detail && event.detail.currentElement);
  }

  function init(component) {
    if (!component || component.dataset.slideshowVideoInit === 'true') return;
    if (!component.querySelector('video[data-slideshow-deferred-video]')) return;

    component.dataset.slideshowVideoInit = 'true';
    component.addEventListener('slideChanged', onSlideChanged);

    const activeSlide =
      component.querySelector('.slideshow__slide.is-active') ||
      component.querySelector('.slideshow__slide');
    syncSlideVideos(component, activeSlide);
  }

  function initAll() {
    document.querySelectorAll('slideshow-component').forEach(init);
  }

  document.addEventListener('shopify:section:load', function (event) {
    const component = event.target.querySelector('slideshow-component');
    if (component) {
      delete component.dataset.slideshowVideoInit;
      init(component);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
